import { Button, Chip, Divider, Stack } from "@mui/material";
import { isEmpty } from "lodash";
import { OrderItem as OrderItemType, ItemStatus } from "../../../types/items";
import { OrderItem } from "../../../components";
import { groupByStatus } from "../utils";
import { requestItemsReview } from "../slice";
import { useAppDispatch } from "@/hooks";
import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import AppConfig from "@/components/AppConfig";
import { Configs } from "@/constants/configs";

const STATUS_CONFIG: Record<ItemStatus, { index: number; label: string; color: string }> = {
  draft: {
    index: 0,
    label: "Sin Ordenar",
    color: "default",
  },
  reviewing: {
    index: 1,
    label: "Revisando",
    color: "info",
  },
  preparing: {
    index: 2,
    label: "Preparando",
    color: "warning",
  },
  delivered: {
    index: 3,
    label: "Entregado",
    color: "success",
  },
  paid: {
    index: 4,
    label: "Pagado",
    color: "error",
  },
};

interface Props {
  items: OrderItemType[];
  variant?: 'dense' | 'expanded';
  onClose?: () => void;
}

const OrderItemsList = ({ items, variant = 'dense', onClose }: Props) => {
  const { DRAFT } = ItemStatus;
  const dispatch = useAppDispatch();
  const order = useSelector((state: RootState) => state.order);

  if (isEmpty(items)) return null;

  return (
    <>
      {Object.entries(groupByStatus(items)).map(([itemStatus, items], index) => (
        <div key={`${itemStatus}-${index}`}>
          <Stack spacing={2} px={3} py={2}>
            <AppConfig isEnabled={Configs.ADD_ORDER}>
              <Stack sx={{ alignItems: "start", justifyContent: "center" }}>
                <Chip {...STATUS_CONFIG[itemStatus as ItemStatus]} />
              </Stack>
            </AppConfig>

            {items.map((item) => (
              <OrderItem key={item.id} {...item} variant={variant as any} canEdit={[DRAFT].includes(item.status)} onClose={onClose} />
            ))}
          </Stack>

          <AppConfig isEnabled={Configs.ADD_ORDER}>
            {Object.values(items).find(({ status }) => status === DRAFT) ? (
              <Stack spacing={2}>
                <Stack alignItems={"center"}>
                  <Button
                    sx={{
                      borderRadius: "33px",
                    }}
                    variant="outlined"
                    onClick={() => dispatch(requestItemsReview(order))}
                  >
                    Ordenar
                  </Button>
                </Stack>
                <Divider />
              </Stack>
            ) : null}
          </AppConfig>
        </div>
      ))}
    </>
  );
};

export default OrderItemsList;
